import React from 'react';

import './index.scss';

function ShowMore(props) {

  let label = 'Show more';

  if (props.failed === true) {
    label = 'Retry';
  }

  let className = 'data-collection-show-more';

  if (props.loading === true) {
    className = `${className} loading`;
  }

  const buttonAttributes = {
    type: 'button',
    className: 'data-collection-show-more-button',
    disabled: props.loading,
    onClick: props.onClick
  };

  return <div className={className} contentEditable={false}>
    <button {...buttonAttributes}>
      <ht-spinner size="small" />
      <span className="data-collection-show-more-label">{label}</span>
    </button>
  </div>;

}

export default ShowMore;
